import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { useTheme } from "@mui/material/styles";
import { Box, Link, Stack, Typography } from "@mui/material";
import { base64_images } from "../../constants/ImageConstants";
import VisibilityIcon from "@mui/icons-material/Visibility";

// ----------------------------------------------------------------------

const Logo = forwardRef(
  ({ disabledLink = false, sx, isObjectFix, ...other }, ref) => {
    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width: 45,
          height: 45,
          display: "inline-flex",
          ...sx,
        }}
        {...other}
      >
        <img src={base64_images.Logo_Icon} />
      </Box>
    );
    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} to="/" sx={{ display: "contents" }}>
        {logo}
      </Link>
    );
  }
);

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
